import { authService } from "#src/services/auth";
import workspaceServices from "#src/services/workspace";
import store from "#src/store";
import {
  updateCurrentWorkspaceV2,
  updateUserInfo,
} from "#src/store/slices/auth";
import { apiErrorHandler } from "#src/utils/apiErrorHandler";
import {
  generatePath,
  LoaderFunction,
  Outlet,
  useParams,
} from "react-router-dom";
import { pathname } from "#src/config/pathname";

/** Guarantee that every routes inside this wrapper have a valid user.
 * @todo move this inside a client component to avoid re-fetch every time anything change, since Component will not be re-rendered, but loader WILL re-run.
 */
export const userProviderLoader: LoaderFunction = () => {
  authService
    .getAccount()
    .then((response) => {
      store.dispatch(updateUserInfo(response));
    })
    .catch(apiErrorHandler);

  return null;
};

/** Guarantee that every routes inside this wrapper have a valid workspace.
 * @todo move this inside a client component to avoid re-fetch every time anything change, since Component will not be re-rendered, but loader WILL re-run.
 */
export const workspaceProviderLoader: LoaderFunction = async ({ params }) => {
  const workspaceId = params.workspaceId;

  if (workspaceId) {
    await workspaceServices
      .retrieve_workspace(workspaceId)
      .then((response) => {
        store.dispatch(updateCurrentWorkspaceV2(response));
      })
      .catch((error) => {
        if (error?.response?.data?.code === "16002") {
          window.location.replace(
            generatePath(pathname.ENABLE_2FA, { workspaceId })
          );
        } else {
          apiErrorHandler(error);
        }
      });
  }

  // If things went smoothly we can just continue. Currently our "home page" is Asset Domain
  return null;
};

export const WorkspaceLayout = () => {
  const { workspaceId } = useParams<"workspaceId">();

  if (!workspaceId) return <div>No workspace selected</div>;
  return <Outlet context={{ workspaceId }} />;
};
